import { z } from "zod";

export const configRoleSchema = z.object({
  name: z.string().min(1, "Role Name is required"),
  description: z.string().min(1, "Description is required"),
  permissionNames: z.array(z.string()).optional(),
  workPermissionNames: z.array(z.string()).optional(),
  departmentId: z.string().min(1, "Department is required"),
});
